import { motion } from "framer-motion";
import { Check, Star, Gift, TrendingUp } from "lucide-react";
import { PLANS, waLink, tgLink } from "@/data/site";
import { ZelleCheckout } from "@/components/landing/ZelleCheckout";
import { CashAppCheckout } from "@/components/landing/CashAppCheckout";

export const Pricing = () => {
  return (
    <section id="planes" data-testid="pricing-section" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-2xl mx-auto"
        >
          <span className="text-sm text-bp-primary uppercase tracking-[0.2em] font-semibold">Planes y precios</span>
          <h2 className="font-heading text-3xl lg:text-5xl font-semibold tracking-tight mt-4">
            ¡Entre más tiempo contratas, más ahorras!
          </h2>
          <p className="mt-4 text-[#A3A3A3]">
            Más meses, más contenido y menor precio por mes. Promoción con <strong className="text-bp-accent">meses GRATIS</strong> incluidos.
          </p>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 items-stretch">
          {PLANS.map((p, i) => {
            const highlighted = p.badge === "Mejor valor";
            return (
              <motion.div
                key={p.name}
                data-testid="pricing-card"
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.07 }}
                className={`relative flex flex-col rounded-2xl p-7 transition-all duration-300 hover:-translate-y-1 ${
                  highlighted
                    ? "border-2 border-bp-accent bg-bp-surface2 shadow-[0_8px_40px_rgba(255,138,30,0.28)] lg:scale-[1.03]"
                    : "border border-bp-border bg-bp-surface hover:border-bp-primary/40"
                }`}
              >
                {p.badge && (
                  <span
                    className={`absolute -top-3 left-1/2 -translate-x-1/2 inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-semibold ${
                      highlighted ? "bg-bp-accent text-black" : "bg-bp-surface2 text-bp-primary border border-bp-primary/40"
                    }`}
                  >
                    <Star className="w-3 h-3 fill-current" /> {p.badge}
                  </span>
                )}
                <h3 className="font-heading text-xl font-medium text-white">{p.name}</h3>
                {p.bonus && (
                  <span
                    data-testid="plan-bonus"
                    className="mt-2 inline-flex items-center gap-1.5 self-start rounded-full bg-bp-accent/15 px-3 py-1 text-xs font-bold text-bp-accent border border-bp-accent/30"
                  >
                    <Gift className="w-3.5 h-3.5" /> {p.bonus}
                  </span>
                )}
                <div className="mt-4 flex items-end gap-1">
                  <span className="text-sm text-[#737373] mb-1.5">$</span>
                  <span className="font-heading text-5xl font-semibold text-white">{p.price}</span>
                  <span className="text-sm text-[#737373] mb-1.5">{p.period}</span>
                </div>
                <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs">
                  <span className="text-white font-semibold">{p.totalLabel}</span>
                  <span className="text-[#737373]">·</span>
                  <span className="text-[#A3A3A3]">{p.perMonth}</span>
                  {p.savings && (
                    <span className="inline-flex items-center gap-1 rounded-full bg-[#25D366]/15 px-2 py-0.5 font-semibold text-[#25D366]">
                      <TrendingUp className="w-3 h-3" /> {p.savings}
                    </span>
                  )}
                </div>
                <ul className="mt-6 space-y-3 flex-1">
                  {p.features.map((f) => (
                    <li key={f} className="flex items-start gap-2.5 text-sm text-[#A3A3A3]">
                      <Check className="w-4 h-4 text-bp-primary mt-0.5 shrink-0" />
                      {f}
                    </li>
                  ))}
                </ul>
                <a
                  href={waLink(`Hola, quiero contratar el plan ${p.name}${p.bonus ? ` (${p.bonus})` : ""} de BrothersPlus TV.`)}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`pricing-whatsapp-${i}`}
                  className={`mt-7 inline-flex items-center justify-center rounded-full px-5 py-3 text-sm font-semibold transition-all duration-200 active:scale-95 ${
                    highlighted
                      ? "bg-bp-accent text-black hover:bg-bp-accentHover hover:shadow-[0_0_22px_rgba(255,138,30,0.5)]"
                      : "bg-white/5 text-white border border-white/10 hover:bg-bp-primary hover:border-bp-primary"
                  }`}
                >
                  Contratar por WhatsApp
                </a>
                <ZelleCheckout plan={p.name} price={p.price} highlighted={highlighted} />
                <CashAppCheckout plan={p.name} price={p.price} highlighted={highlighted} />
                <a
                  href={tgLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`pricing-telegram-${i}`}
                  className="mt-2 text-center text-xs text-[#737373] hover:text-white transition-colors"
                >
                  o escríbenos por Telegram
                </a>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
